import { Controller } from "@hotwired/stimulus"

// Auto-submits a form when triggered (e.g., on select change)
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
